export enum DeliveryType {
  Bank = 'bank',
  Card = 'card',
  CardCost = 'card-cost'
}
